<template>
  <div>

    <button v-if="!controlerBtnSubmit" class="btn btn-primary" v-on:click="abrirModal()" href="javascript:void(0)">Fechamento Fixo e Variável</button>
    <button v-else type="button" class="btn btn-primary" disabled><i class='fa fa-refresh fa-spin'></i> Carregando Fechamento Fixo e Variável...</button><br>
    <span v-if="controlerBtnSubmit" style="font-size: 10px;color: red;">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-exclamation-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
      </svg> <b>O tempo de download pode variar conforme o número de estados do usuário.</b>
    </span>

    <!-- <modal-fechamento-fixo-variavel @selecionado="downloadAnexo"/> -->
    <modal-fechamento-fixo-variavel @selecionado="downloadAnexo" />

  </div>
</template>

<script>
import modalFechamentoFixoVariavel from '../../modal/FechamentoFixoVariavel.vue'

export default {
  data() {
    return {
      env: process.env,
      controlerBtnSubmit: false
    }
  },
  components: {
    'modal-fechamento-fixo-variavel': modalFechamentoFixoVariavel
  },
  mounted: function () {
  },
  methods: {
    abrirModal() {
      this.$store.commit('setModalFechamentoFixoVariavel', { show: true })
    },
    downloadAnexo(mesAno) {
      this.controlerBtnSubmit = true
      let vm = this
      let payload = {
        estado: this.$store.state.login.loginUsuario.estado,
        mes: mesAno.split('-')[1],
        ano: mesAno.split('-')[0]
      }
      this.$axios.post(`${this.env.FINANCEIRO.SLA}/exportFechamentoFixoVariavel`, payload, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          let arquivoDownload = response.data.arquivo_download

          // Redirecionar a janela atual para o link de download.
          // Obs.: Remove o final 'api' do env.FINANCEIRO.SLA, pois, a rota é web.
          window.location.href = vm.env.FINANCEIRO.SLA.slice(0, -3) + 'download-arquivo-xlsx/' + arquivoDownload

          setTimeout(() => {
            vm.controlerBtnSubmit = false
          }, 10000)
        } else {
          vm.$store.commit('setAlert', { msg: response.data.erro, status: false, show: true })
          vm.controlerBtnSubmit = false
        }
      }).catch(() => {
        this.controlerBtnSubmit = false
      })
      console.log(payload)
    }
  }
}
</script>

<style scoped>
button:hover {
  background-color: #6c757d;
}

/* button {
  background-color: #3c7fe4;
  color: white;
  margin: 1%;
  margin-right: 5px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 5px;
  padding-top: 5px;
  border-style: none;
  border-radius: 5px;
  width: 160px;
  height: 50px;
} */
</style>



// WEBPACK FOOTER //
// ExportFechamentoFixoVariavel.vue?7967367a